import { render, staticRenderFns } from "./RichTextEditor.vue?vue&type=template&id=2071fd64&scoped=true"
import script from "./RichTextEditor.vue?vue&type=script&lang=ts"
export * from "./RichTextEditor.vue?vue&type=script&lang=ts"
import style0 from "./RichTextEditor.vue?vue&type=style&index=0&id=2071fd64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2071fd64",
  null
  
)

export default component.exports